"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsStationModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _material = require("@mui/material");
var _DmsTableProductionOrderStation = require("./DmsTableProductionOrderStation");
var _DmsButton = require("../../DmsButton/DmsButton");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * DmsStationModal component
 * 
 * @param {object} show - control useState modal
 * @param {object} onHide - control to close a modal
 * @param {object} row_data - data of row in DmsTable
 * @param {string} title - optional parameter to change a title, default is Stationes
 */

const DmsStationModal = _ref => {
  let {
    show,
    onHide,
    row_data,
    title = _reactIntlUniversal.default.get("Station").d("Station")
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_material.Dialog, {
    open: show,
    onClose: onHide,
    fullWidth: true,
    maxWidth: "lg"
  }, /*#__PURE__*/_react.default.createElement(_material.DialogTitle, null, title), /*#__PURE__*/_react.default.createElement(_material.DialogContent, {
    dividers: true,
    style: {
      maxHeight: '70vh',
      overflowY: 'auto'
    }
  }, /*#__PURE__*/_react.default.createElement(_DmsTableProductionOrderStation.DmsTableProductionOrderStation, {
    row_data: row_data
  })), /*#__PURE__*/_react.default.createElement(_material.DialogActions, null, /*#__PURE__*/_react.default.createElement(_DmsButton.DmsButton, {
    onClick: onHide,
    variant: "text",
    color: "primary",
    size: "medium"
  }, _reactIntlUniversal.default.get("Close").d("Close"))));
};
exports.DmsStationModal = DmsStationModal;